<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
             <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container py-0 pb-5">
            <div class="row row-grid justify-content-between align-items-center">
                <div class="col-lg-6">
                    <h3 class="display-3 text-white">How It Works
                    </h3>
                    <p class="lead text-white">After sending us your request, our professional team will make a customized plan with specfic solutions and services. A combination of human work, autonomous data tools, machine learning techniques and integrated process will be used to guarantee the high quality of our solutions and services.</p>
                    <div class="btn-wrapper">
                        <router-link to="/contact" class="btn btn-primary">
                            Contact us
                        </router-link>
                    </div>
                </div>
                <div class="col-lg-5 mb-lg-auto">
                    <div class="transform-perspective-right">
                        <card class="border-0" type="secondary" shadow
                              body-classes="px-lg-5 py-lg-5"
                              header-classes="pb-5 bg-white">
                            
                                <div class="btn-wrapper text-center">
                                    <base-button type="neutral">
                                        <i class="fa fa-send"></i>
                                        Sending your Request
                                    </base-button>
                                    <br/>
                                    <div class="text-center" type="neutral">
                                        <i class="fa fa-arrow-down"></i> 
                                    </div>      
                                    <base-button type="neutral">
                                        <i class="fa fa-comments"></i>
                                        Project Discussion
                                    </base-button>
                                    <br/>
                                    <div class="text-center" type="neutral">
                                        <i class="fa fa-arrow-down"></i> 
                                    </div>
                                    <base-button type="neutral">
                                        <i class="fa fa-calendar"></i>
                                        Custmized Plan
                                    </base-button>
                                    <br/>
                                    <div class="text-center" type="neutral">
                                        <i class="fa fa-arrow-down"></i> 
                                    </div>
                                    <base-button type="neutral">
                                        <i class="fa fa-bookmark"></i>
                                        Demo Exhibition
                                    </base-button>
                                    <br/>
                                    <div class="text-center" type="neutral">
                                        <i class="fa fa-arrow-down"></i> 
                                    </div>
                                    <base-button type="neutral">
                                        <i class="fa fa-play"></i>
                                        Project Excution
                                    </base-button>
                                    <br/>
                                    <div class="text-center" type="neutral">
                                        <i class="fa fa-arrow-down"></i> 
                                    </div>
                                    <base-button type="neutral">
                                        <i class="fa fa-eye"></i>
                                        Quality Inspection
                                    </base-button>
                                    <br/>
                                    <div class="text-center" type="neutral">
                                        <i class="fa fa-arrow-down"></i> 
                                    </div>
                                    <base-button type="neutral">
                                        <i class="fa fa-certificate"></i>
                                        Project Acceptance
                                    </base-button>
                                </div>
                         
                        </card>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
